import axios from 'axios';
import Cookies from 'js-cookie';
import { BASE_URL } from '../actions';

export const billingEnabled = process.env.REACT_APP_BILLING_V2_ENABLED === 'true';
// Isolate payment setup from Redux, persisted state and legacy request retries.
const client = axios.create({ baseURL: `${BASE_URL}/billing`, timeout: 30000 });
async function request(method, path, data, params) {
  try {
    const response = await client.request({ method, url: path, data, params,
      headers: { Authorization: `Bearer ${Cookies.get('token')}` } });
    if (!response.data?.ok) throw new Error('Invalid billing response');
    return response.data.data;
  } catch (error) {
    // Never propagate Axios request/response objects containing setup secrets.
    const safe = new Error(error.response?.data?.message || 'Unable to load or update billing. Please try again.');
    safe.code = error.response?.data?.code || 'billing_unavailable';
    safe.status = error.response?.status;
    throw safe;
  }
}
export const billingApi = {
  status: () => request('get', '/status'),
  account: () => request('get', '/account'),
  startSetup: data => request('post', '/setup', data),
  completeSetup: setup_id => request('post', '/setup/complete', { setup_id }),
  chooseRequiredPlan: version_key => request('put', '/required-plan', { version_key }),
  chooseSignupPlan: version_key => request('put', '/signup/plan', { version_key }),
  changePlan: data => request('put', '/plan', data),
  cases: page => request('get', '/cases', undefined, { page, page_size: 20 }),
  enrollment: id => request('get', `/cases/${id}`),
  setEnrollment: (id, data) => request('put', `/cases/${id}`, data),
  preview: (year, month) => request('get', '/preview', undefined, { year, month }),
};

export const money = (cents, currency = 'usd') => new Intl.NumberFormat('en-US', {
  style: 'currency', currency, minimumFractionDigits: cents % 100 ? 2 : 0,
}).format(cents / 100);
export function easternMonth(asOf) {
  const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: 'numeric' })
    .formatToParts(new Date(asOf));
  return ['year', 'month'].map(type => Number(parts.find(part => part.type === type).value));
}
